<template>
	<div class="start qjc-clearfix qjc-flex">
		<div v-if="list.length > 0" class="left">
			<ul class="qjc-flex">
				<li v-for="item in list" @click="activeDay = item.day" :class="{ 'active': item.day == activeDay }" :style="{ flex: 1/list.length }">第{{ numString[item.day-1] }}天</li>
			</ul>
			<video :src="course.video" :poster="course.cover" controls></video>
		</div>
		<div v-if="list.length > 0" class="right">
			<h3>{{ course.title }}</h3>
			<p>{{ joinCount }}人和您一起参加</p>
			<div>
				{{ course.description }}
			</div>
		</div>
		
		<div v-if="list.length <= 0" class="no-course">
			 <span v-if="beginDay > 0">{{ beginDay }}天后进行</span>
			 <span v-if="beginDay == 0">正在进行</span>
			 <span v-else>已结束</span>
			 {{ joinCount }}人参加
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Toast } from 'vant'
	Vue.use(Toast);
	
	import { courseDetail } from "@/utils/axios"
	
	export default{
		name: "dayuCourse",
		data() {
			return {
				numString: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
				
				list: [],
				
				beginDay: -1,
				joinCount: 0,
				
				activeDay: 0,// 展示第N天课程信息，默认0
				
				course: {
					title: '',
					video: '',
					cover: '',
					description: ''
				}
			}
		},
		mounted() {
			this.getDetail();
		},
		watch: {
			activeDay(val) {
				this.course = this.list.filter(a => a.day == val)[0];
			}
		},
		methods: {
			getDetail() {
				var that = this;
				
				courseDetail(this.$route.params.id).then(res => {
					console.log(res)
					
					if(res.errno == 0){
						var data = res.data;
						
						that.list = data.courses;
						that.beginDay = data.beginDay;
						that.joinCount = data.joinCount;
						
						that.list.length>0?that.activeDay = 1:'';// 存在课程,默认第一天开始
						
					}else{
						Toast.fail(res.errmsg);
					}
					
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.start{
		justify-content: flex-start;
		align-items: center;
		height: 9.9rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		padding-left: 0.8rem;
		overflow-y: auto;
		
		
		.no-course{
			flex: 1;
			text-align: center;
			color: #E1E7F5;
			font-size: 0.32rem;
		}
		
		.left{
			width: 13.38rem;
			border-radius: 0 0 0.08rem 0.08rem;
			overflow: hidden;
			
			ul{
				width: 100%;
				height: 0.8rem;
				line-height: 0.8rem;
				
				li{
					font-size: 0.28rem;
					color: rgba(141, 145, 153, .9);
					text-align: center;
					border: 0.01rem solid rgba(96, 104, 118, .6);
					cursor: pointer;
					
					&.active{
						color: #5FD6FF;
						background-color: rgba(20, 72, 117, .7);
						border-color: #5FD6FF;
						box-shadow: 0 0 0.16rem #509AE3 inset;
					}
					
					&:first-child{
						border-top-left-radius: 0.08rem;
					}
					&:last-child{
						border-top-right-radius: 0.08rem;
					}
				}
			}
			
			video{
				width: 100%;
				height: 8.04rem;
				object-fit: fill;
				
				&:focus{
					border: none;
					outline: none;
				}
			}
		}
	
		.right{
			align-items: center;
			width: 4.2rem;
			margin-left: 0.32rem;
			
			h3{
				font-size: 0.48rem;
				line-height: 0.56rem;
				color: #E1E7F5;
				font-weight: 500;
			}
			p{
				font-size: 0.24rem;
				line-height: 0.24rem;
				color: #8D9199;
				margin: 0.32rem 0 0.4rem;
			}
			div{
				color: #BCC1CC;
				font-weight: 300;
				font-size: 0.32rem;
				line-height: 0.44rem;
			}
		}
	}
</style>
